import { BaseActivityModel } from '../base-activity.model';
import { TransactionalEmailRecordModel } from './transactional-email-record.model';
import { EmbeddedLinkModel } from '../embedded-link.model';

export interface TransactionalEmailActivityModel extends BaseActivityModel {
  scheduledTimestamp?: Date;

  emailFrom: string;
  emailFromName: string;
  mailServerId?: number | null;
  emailSubject: string;
  emailContent: string;
  emailMjmlContent: string;
  emailAttachmentFileName?: string;

  smsContent?: string;

  emailTotal: number;
  emailStatusBounced: number;
  emailStatusBouncedSkip: number;
  emailStatusOpened: number;
  emailStatusSent: number;
  emailStatusUnsubscribed: number;
  emailStatusUnsubscribedSkip: number;
  emailStatusAcknowledge: number;

  sendWhatsAppMessage: boolean;
  whatsAppTemplateName: string;
  whatsAppBodyContent: string;
  whatsAppDocument: boolean;
  whatsAppFooterContent: string;
  whatsAppButton: string;

  htmlTemplateName?: string;
  htmlTemplateContent?: string;
  sftp?: boolean;
  sftpPath?: string;

  records: TransactionalEmailRecordModel[];

  embeddedLinks: EmbeddedLinkModel[];
}
